
import { sync } from 'vuex-pathify'

export default {
  props: {
    slides: {
      type: Array,
      default: null
    }
  },
  vessel: {
    boxParent: {
      pinRight: true,
      pinBottom: true,
      position: 'absolute',
      padding: 'md'
    },
    box: {
      backgroundColor: 'white',
      paddingY: 'xl',
      paddingX: 'lg',
      textAlign: 'center',
      shadow: 'lg',
      width: '5xl',
    },
    title: {
      marginBottom: 'xs',
      fontSize: 'lg',
      fontWeight: 'semibold'
    },
    text: {
      lineHeight: 'md'
    },
    navItem: {
      borderLeftWidth: 2,
      cursor: 'pointer'
    }
  },
  computed: {
    selectedSolution: sync('registerForm@solution')
  },
  methods: {
    onButtonClick({ solution }) {
      this.selectedSolution = solution
    }
  }
}
